import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'se-fe-footer',
  templateUrl: 'se-fe-footer.component.html',
  styleUrls: ['se-fe-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SeFeFooterComponent {}
